import React from 'react'
import clsx from 'clsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TESTS_STATES, boardTone, boardDot } from '../helpers'

const TestsStatus = ({ issue, states, saving, onChange }) => (
  <div className="flex items-center gap-2">
    {saving && <FontAwesomeIcon icon="circle-notch" spin className="text-[12px] text-slate-400" />}
    <div className="inline-flex items-center gap-1 rounded-lg bg-slate-100 p-1" role="radiogroup">
      {TESTS_STATES.filter(s => states.some(o => o.key === s.key)).map(s => {
        const active = issue.tests_state === s.key
        const color  = states.find(o => o.key === s.key).color
        return (
          <button
            key={s.key}
            type="button"
            role="radio"
            aria-checked={active}
            disabled={saving}
            onClick={() => !active && onChange(issue, s.key)}
            className={clsx(
              'inline-flex h-8 items-center gap-1.5 rounded-md border-0 px-[12px] font-sans text-[12.5px] font-medium transition focus:outline-none disabled:cursor-default',
              active ? clsx(boardTone(color), 'shadow-sm') : 'bg-white/0 text-slate-500 hover:bg-white hover:text-slate-800'
            )}
          >
            <span className={clsx('h-2.5 w-2.5 shrink-0 rounded-full border-[1.5px] border-solid', boardDot(color))} />
            {s.label}
          </button>
        )
      })}
    </div>
  </div>
)

export default TestsStatus
